// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_ho","advertCardHeader__actions":"c-a_hp","advertCardHeader__bottomLabel":"c-a_hq"};